import { render, staticRenderFns } from "./form.vue?vue&type=template&id=e28dbb9c&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=e28dbb9c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28dbb9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e28dbb9c')) {
      api.createRecord('e28dbb9c', component.options)
    } else {
      api.reload('e28dbb9c', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=e28dbb9c&scoped=true", function () {
      api.rerender('e28dbb9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/contract/form/form.vue"
export default component.exports